const { debounce } = require("../utils/debounce");
const { a11yClick } = require("../utils/a11yClick");

const $ = window.jQuery;
const $window = window.$window || $(window);

module.exports = {

    init: function () {
        /**
         * 
         * CUSTOM STARTS HERE
         * 
         */
        /**
         * Replace favicon based on @media
         */
         var lightSchemeIcon = $('.light-scheme-icon');
         var darkSchemeIcon = $('.dark-scheme-icon');
 
         function onUpdate(matcher) {
             if (matcher.matches) {
                 lightSchemeIcon.remove();
                 $('head').append(darkSchemeIcon);
             } else {
                 $('head').append(lightSchemeIcon);
                 darkSchemeIcon.remove();
             }
         }
         var matcher = window.matchMedia('(prefers-color-scheme: dark)');
         onUpdate(matcher);

        /**
         * Menu Toggle
         */
        $(document).on('click keypress', '.menu-toggle', function (e) {
            if ( a11yClick(e) === true ) {
                e.preventDefault();

                var $toggle = $(this),
                    $wrapper = $toggle.parents('.site-header');

                if ( window.matchMedia("(min-width: 768px)").matches ) {
                    var $slide = $wrapper.find('.header__slide')
                } else {
                    var $slide = $wrapper.find('.header__slide, .header__slide--alt')
                }

                if ( $wrapper.hasClass('active') ) {
                    $slide.slideUp(150, function() {
                        $wrapper.removeClass('active');
                        $toggle.removeClass('active');
                    });
                } else {
                    $slide.css('display', 'flex').hide().slideDown(150, function() {
                        $wrapper.addClass('active');
                        $toggle.addClass('active');
                    });
                }
            }
        });

        /**
         * Resize Header on Scroll
         */
        var $toggle = $('.menu-toggle'),
            $wrapper = $toggle.parents('.site-header');

        if ( window.matchMedia("(min-width: 768px)").matches ) {
            var $slide = $wrapper.find('.header__slide')
        } else {
            var $slide = $wrapper.find('.header__slide, .header__slide--alt')
        }

        const $headerHeight = $('#masthead').outerHeight();

        $(function(){
            $wrapper.data('size','large');
        });

        $(window).scroll( debounce(10, function() {
            if( $(document).scrollTop() > $headerHeight) {
                if($wrapper.data('size') == 'large') {
                    $wrapper.data('size','small');

                    $slide.slideUp(200, function() {
                        $wrapper.removeClass('active');
                    });
                    $toggle.slideDown(150);
                }
            } /* else if ( $(document).scrollTop() <= 0 ) {
                console.log( 'else', $(document).scrollTop() );
                if($wrapper.data('size') == 'small') {
                    $wrapper.data('size','large');

                    $slide.css('display', 'flex').hide().slideDown(200, function() {
                        $wrapper.addClass('active');
                    });
                    $toggle.slideUp(150);
                }
            } */
        }, false));

        /**
         * Expand Film Details
         */
        $(document).on('click keypress', '.film__link, .film__link--alt', function(e) {
            if ( a11yClick(e) === true ) {
                e.preventDefault();

                if ( $(this).hasClass('film__link--alt') ) {
                    var $toggle = $(this).parent().find('.film__link');
                } else {
                    var $toggle = $(this);
                }

                var $parent = $toggle.parents('.film'),
                    $more = $parent.find('.film__details');

                console.log($parent)

                if ( $parent.hasClass('active') ) {
                    $toggle.text($toggle.data('more'));

                    $more.slideUp(300, function() {
                        $parent.removeClass('active');
                        $toggle.removeClass('active');
                    });
                } else {
                    $toggle.text($toggle.data('less'));

                    $more.slideDown(300, function() {
                        $parent.addClass('active');
                        $toggle.addClass('active');
                    });
                }
            }
        } );

        /**
         * Expand Search Bar
         */
        $(document).on('click keypress', '.header-icons__search',function(e) {
            e.preventDefault();

            var searchBar = $(this).parent().parent().find('.search-bar'),
                searchInput = searchBar.find('.proinput input.orig'),
                speed = 150;

            if (searchBar.is(':visible')) {
                searchBar.slideUp(speed);
            } else {
                searchBar.css('display', 'flex').hide().slideDown(speed, function() {
                    searchInput.focus();
                });
            }
        });

		$(document).on( 'mouseup.krokodilDropdown touchend.krokodilDropdown focusin.krokodilDropdown', function( e )  {
			var container = $('.search-bar:visible');
            var searchResults = $('#ajaxsearchprores1_1:visible');

			if (!container.is(e.target) && container.has(e.target).length === 0) 
			{
				container.slideUp(150);
				searchResults.slideUp(150);
			}
		});

        $(document).on('keydown.krokodilDropdown', function( e ){
            var searchResults = $('#ajaxsearchprores1_1:visible');
            
			if(e.which==27) {
				$('.search-bar').slideUp(150);
				searchResults.slideUp(150);
			}
		});

    }
};